import React, { Component } from 'react'
/*eslint-disable */
class AccordionElement extends Component {

  getItemHeight = () => {
    const Item = this.item
    if(!Item){
      return 40
    }
    return Item.scrollHeight
  }

  getChildHeight = () => {
    const Child = this.child
    const Item = this.item
    if(!Child || !Item){
      return 40
    }
    return Child.scrollHeight + Item.scrollHeight
  }

  render() {
    const {
      label,
      isActive,
      onTouchTap,
      isLargePadded,
      borderNotShow,
    } = this.props;
    return (
      <div
        className="accordionModule"
        style={{
          transition: '0.1s',
          overflow: 'hidden',
          height: isActive ? this.getChildHeight() : this.getItemHeight(),
          borderBottom: !borderNotShow ? '1px solid #e8e8e8': '0px',
          cursor: 'pointer',
        }}
      >
        <a
          ref={(item) => this.item = item}
          onClick={onTouchTap}
          style={{
            display: 'flex',
            justifyContent: 'space-between',
            color: '#616161',
            transition: '0.3s',
            fontSize: 15,
            padding: 10,
            fontWeight: 500,
          }}
        >
          {label}
          <i className={`fa fa-angle-${isActive ? 'up':'down'}`}/>
        </a>
        <div
          style={{ padding: isLargePadded ? '0 20px 20px' : '0 10px' }}
          ref={(child) => this.child = child}
        >
          {this.props.children}
        </div>
      </div>
    )
  }
}

AccordionElement.propTypes = {}
AccordionElement.defaultProps = {}

export default AccordionElement



// WEBPACK FOOTER //
// ./src/components/accordions/AccordionElement.js